import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is automation consultancy, and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Automation can help improve efficiency, reduce errors and costs, and free up
                                        human resources for higher-value tasks. Automation consultancy involves working
                                        with a team of experts to assess your business processes and identify
                                        opportunities for automation. By working with an automation consultancy firm
                                        like TekRevol, you can get expert advice on implementing automation in your
                                        business and realize its benefits.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What services does TekRevol offer in the field of automation consultancy?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol offers several automation consultancy services, including process
                                        assessment and optimization, automation planning and implementation, and ongoing
                                        support and maintenance. Our team of experts can help you understand the
                                        potential benefits of automation for your business and develop a customized
                                        strategy to implement and optimize automation practices.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    What are business automation services?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Business automation refers to the utilization of technological applications that handle repetitive tasks, thereby liberating employees to engage in more valuable activities.</p>
                                    <p>This encompasses various forms of automation, including business process automation (BPA), robotic process automation (RPA), and AI-driven automation.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    What does a business automation consultant do?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Automation consulting is a critical service that helps businesses optimize their operations, reduce costs, and increase productivity.</p>
                                    <p>By harnessing automation tools, strategies, and approaches, companies can attain a competitive advantage and concentrate on promoting growth.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;